import wordsCounter from 'word-counting';

export default function getWordCount(text: string, isHtml = false): number {
    return wordsCounter(text, { isHtml }).wordsCount;
}
